import { FormLayout, FormSection } from "@excent-one/react";
import { ContentLayout } from "@excent-one/react/layout/content";
import { StackLayout } from "@progress/kendo-react-all";
import { Typography } from "@progress/kendo-react-common";

interface PlaceholderPageProps {
  title?: string;
}

const PlaceholderPage = ({ title }: PlaceholderPageProps) => (
  <ContentLayout>
    <ContentLayout.Header>
      <ContentLayout.Header.Title title={title} />
      <ContentLayout.Header.Breadcrumbs />
      <ContentLayout.Header.BackNavigation />
    </ContentLayout.Header>
      <FormLayout>
        <FormSection title="Content">
          <StackLayout orientation="horizontal">
            <Typography.h6>Ongoing development.</Typography.h6>
          </StackLayout>
        </FormSection>
      </FormLayout>
  </ContentLayout>
);

export default PlaceholderPage;
